import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  height: 46px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { FetchingStatus } from '@scp/ui-shared/core';
import { ContentLoaderWrapper, shouldShowLoader, STANDARD_LOADER_CONFIG, TextLoader } from './content-loaders';
var CalendarContentLoader = styled(ContentLoader)(_templateObject());
var SelectFieldWrapper = styled.div(_templateObject2());
var AgendaLoaderWrapper = styled.div(_templateObject3());
/**
 * Calendar loader components
 * @example ./__docs__/CalendarLoader.md
 */

export var CalendarSkeletonLoader = function CalendarSkeletonLoader(_a) {
  var _a$status = _a.status,
      status = _a$status === void 0 ? FetchingStatus.Loading : _a$status,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      id = _a.id,
      props = __rest(_a, ["status", "children", "id"]);

  if (!shouldShowLoader(status)) return children;
  return React.createElement(ContentLoaderWrapper, {
    loaderWidth: 100,
    loaderHeight: 280,
    as: 'div',
    fullWidth: true
  }, React.createElement(CalendarContentLoader, Object.assign({}, STANDARD_LOADER_CONFIG, {
    width: 100,
    height: 280,
    uniquekey: id
  }, props), React.createElement("rect", {
    y: "7",
    x: "5",
    width: "90",
    height: "26"
  }), React.createElement("rect", {
    y: "47",
    x: "5",
    width: "90",
    height: "26"
  }), React.createElement("rect", {
    y: "87",
    x: "5",
    width: "90",
    height: "26"
  }), React.createElement("rect", {
    y: "127",
    x: "5",
    width: "90",
    height: "26"
  }), React.createElement("rect", {
    y: "167",
    x: "5",
    width: "90",
    height: "26"
  }), React.createElement("rect", {
    y: "207",
    x: "5",
    width: "90",
    height: "26"
  }), React.createElement("rect", {
    y: "247",
    x: "5",
    width: "90",
    height: "26"
  })));
};
export var AgendaSkeletonLoader = function AgendaSkeletonLoader(_a) {
  var _a$status2 = _a.status,
      status = _a$status2 === void 0 ? FetchingStatus.Loading : _a$status2,
      _a$children2 = _a.children,
      children = _a$children2 === void 0 ? null : _a$children2,
      props = __rest(_a, ["status", "children"]);

  if (!shouldShowLoader(status)) return children;
  return React.createElement(AgendaLoaderWrapper, null, React.createElement(TextLoader, Object.assign({
    width: 100,
    status: FetchingStatus.Loading
  }, props)), React.createElement(SelectFieldWrapper, null, React.createElement(TextLoader, Object.assign({
    width: 200,
    status: FetchingStatus.Loading
  }, props))));
};